import type { Dispatch, SetStateAction } from "react";
import { useCallback } from "react";

import type { CatalystMode } from "#src/contexts/catalyst";

import type {
  CatalystQuestionAndAnswer,
  SwitchToModelExpertPromptHandlers,
} from "../types";
import { isSwitchToModelExpertPrompt } from "../types";

export function useSwitchToModelExpertPromptHandlers({
  currentMode,
  setMode,
  setQuestionsAndAnswers,
}: {
  currentMode: CatalystMode;
  setMode: (mode: CatalystMode) => void;
  setQuestionsAndAnswers: Dispatch<SetStateAction<CatalystQuestionAndAnswer[]>>;
}): SwitchToModelExpertPromptHandlers {
  const onDeclineSwitchToModelExpert = useCallback(
    (questionAndAnswerId: string) => {
      setQuestionsAndAnswers((prevQuestionsAndAnswers) =>
        prevQuestionsAndAnswers.map((prevQuestionAndAnswer) =>
          prevQuestionAndAnswer.id === questionAndAnswerId &&
          isSwitchToModelExpertPrompt(prevQuestionAndAnswer)
            ? {
                ...prevQuestionAndAnswer,
                state: "no",
              }
            : prevQuestionAndAnswer
        )
      );
      setMode(currentMode);
    },
    [currentMode, setMode, setQuestionsAndAnswers]
  );

  const onSwitchToModelExpert = useCallback(
    (questionAndAnswerId: string) => {
      setQuestionsAndAnswers((prevQuestionsAndAnswers) =>
        prevQuestionsAndAnswers.map((prevQuestionAndAnswer) =>
          prevQuestionAndAnswer.id === questionAndAnswerId &&
          isSwitchToModelExpertPrompt(prevQuestionAndAnswer)
            ? {
                ...prevQuestionAndAnswer,
                state: "yes",
              }
            : prevQuestionAndAnswer
        )
      );
      setMode("model-expert");
    },
    [setMode, setQuestionsAndAnswers]
  );

  return {
    onDeclineSwitchToModelExpert,
    onSwitchToModelExpert,
  };
}
